var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('operation-auth-dialog',{attrs:{"open":_vm.visible,"agent-name":_vm.agentName,"loading":_vm.loading,"reject-loading":_vm.rejectLoading},on:{"agree":_vm.handleAgree,"reject":_vm.handleReject,"dismiss":_vm.handleDismiss}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }